<section class="referral-faq">
  <h2 class="referral-faq__title semi-bold">Frequently asked questions</h2>

  <div class="referral-faq__list">
    @for (item of faqItems; track item.question; let i = $index) {
      <div class="referral-faq-item" [class.referral-faq-item--expanded]="isExpanded(i)">
        <button
          type="button"
          class="referral-faq-question"
          (click)="toggle(i)"
          [attr.data-id]="'referral-faq-question-' + i"
          [attr.aria-expanded]="isExpanded(i)"
        >
          <span class="referral-faq-question__text semi-bold">{{ item.question }}</span>
          <span class="referral-faq-question__toggle" aria-hidden="true">
            <ds-icon icon="chevronDown" />
          </span>
        </button>

        @if (isExpanded(i)) {
          <p class="referral-faq-answer" [attr.data-id]="'referral-faq-answer-' + i">
            {{ item.answer }}
          </p>
        }
      </div>
    }
  </div>

  <h2 id="referral-terms" class="referral-faq__terms-title semi-bold">Terms &amp; conditions</h2>
  <p class="referral-faq__terms-body" data-id="referral-terms">{{ termsSummary }}</p>
</section>
